//
// Copyright © 2026 Link Studios
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
import type { Class, Doc, Ref } from '@hcengineering/core'
import { plugin, type Asset, type IntlString, type Plugin } from '@hcengineering/platform'
import type { AnyComponent } from '@hcengineering/ui'
import type { AutomationRequest, AutomationRule, AutomationRun } from './types'

export * from './types'

/**
 * Id del plugin. Lleva prefijo propio para no chocar nunca con un plugin oficial
 * de Huly (en 2022 existió uno llamado «automation»).
 */
export const lsAutomationId = 'lsAutomation' as Plugin

const lsAutomation = plugin(lsAutomationId, {
  class: {
    Rule: '' as Ref<Class<AutomationRule>>,
    Run: '' as Ref<Class<AutomationRun>>,
    Request: '' as Ref<Class<AutomationRequest>>
  },
  app: {
    Automation: '' as Ref<Doc>
  },
  action: {
    RunAutomation: '' as Ref<Doc>
  },
  component: {
    AutomationApp: '' as AnyComponent,
    IssueFooter: '' as AnyComponent,
    RunRulePopup: '' as AnyComponent
  },
  icon: {
    Automation: '' as Asset
  },
  string: {
    Automations: '' as IntlString,
    AutomationsDescription: '' as IntlString,
    Automation: '' as IntlString,
    Rules: '' as IntlString,
    Rule: '' as IntlString,
    Runs: '' as IntlString,
    RunAutomation: '' as IntlString,
    NewRule: '' as IntlString,
    NoRules: '' as IntlString,
    NoRulesHint: '' as IntlString,
    SelectRule: '' as IntlString,
    NoRuns: '' as IntlString,
    NoManualRules: '' as IntlString
  }
})

export default lsAutomation
